import { css, type Theme } from '@emotion/react';

import type { Color } from '@didaskill/types/web';

import { removeButtonAppearance } from '../../../utils/style';
import { MOOD_STATES, MOODS } from './constants';

export const faceColorMap = (theme: Theme): Record<MOODS, Color> => ({
  [MOODS.NEGATIVE]: theme.colors.danger,
  [MOODS.NEUTRAL]: theme.colors.warning,
  [MOODS.POSITIVE]: theme.colors.success,
});

export const faceIllustrationColorMap = (mood: MOODS, state: MOOD_STATES, theme: Theme) => {
  const colorGroup = faceColorMap(theme)[mood];

  if (state === MOOD_STATES.DISABLED) {
    return theme.colors.gray[200];
  }

  if (state === MOOD_STATES.SELECTED) {
    return theme.colors.gray[0];
  }

  return colorGroup[500];
};

export const moodBoxContainer = (theme: Theme) => css`
  ${removeButtonAppearance};

  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  height: 32px;
  width: 32px;
  border-radius: 4px;

  background-color: ${theme.colors.gray[25]};

  &.${MOODS.POSITIVE} {
    &.${MOOD_STATES.SELECTED} {
      background-color: ${faceColorMap(theme)[MOODS.POSITIVE][500]};
    }

    &.${MOOD_STATES.DEFAULT} {
      background-color: ${faceColorMap(theme)[MOODS.POSITIVE][100]};
    }
  }

  &.${MOODS.NEUTRAL} {
    &.${MOOD_STATES.SELECTED} {
      background-color: ${faceColorMap(theme)[MOODS.NEUTRAL][500]};
    }

    &.${MOOD_STATES.DEFAULT} {
      background-color: ${faceColorMap(theme)[MOODS.NEUTRAL][100]};
    }
  }

  &.${MOODS.NEGATIVE} {
    &.${MOOD_STATES.SELECTED} {
      background-color: ${faceColorMap(theme)[MOODS.NEGATIVE][500]};
    }

    &.${MOOD_STATES.DEFAULT} {
      background-color: ${faceColorMap(theme)[MOODS.NEGATIVE][100]};
    }
  }

  &:hover {
    opacity: 0.8;
  }

  transition: ${theme.transitions.default()};
`;

export const negativeMood = css`
  position: absolute;
  top: 17px;
`;

export const neutralMood = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

export const positiveMood = css`
  position: absolute;
  top: 5.33px;
`;
